/**
 * Builds a worker using webpack's static analysis for `new Worker(new Url(...))` but allows loading
 * from a remote cdn / source.
 *
 * See https://github.com/webpack/webpack/discussions/14648#discussioncomment-2559969 for workaround
 * source.
 */
export class CorsWorker {
  worker: Worker;

  constructor(url) {
    const absoluteUrl = new URL(url, window.location.href).toString();
    const workerSource = `\
  const urlString = ${JSON.stringify(absoluteUrl)}
  const originURL = new URL(urlString)
  const originalImportScripts = self.importScripts
  self.importScripts = (url) => originalImportScripts.call(self, new URL(url, originURL).toString())
  importScripts(urlString);
`;
    const blob = new Blob([workerSource], { type: 'application/javascript' });
    const objectURL = URL.createObjectURL(blob);
    this.worker = new Worker(objectURL);
    URL.revokeObjectURL(objectURL);
  }

  getWorker() {
    return this.worker;
  }
}
